import get from 'lodash/get';
import { useContext, useState, useEffect } from 'react';
import { useHistory, useLocation, Redirect } from 'react-router-dom';

import { DelayedLoadingIndicator } from '@numbox/components';

import { ExistingAccountView } from './ExistingAccountView';
import { LoginContext } from './LoginContext';
import { ROUTES } from './constants';

export const ExistingAccount = () => {
  const { email, setEmail } = useContext(LoginContext);
  const [emailNotFoundInLocation, setEmailNotFoundInLocation] = useState(false);

  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (email) {
      // Email has been set, nothing to do.
      return;
    }

    const emailFromLocation = get(location, 'state.email');

    if (emailFromLocation) {
      setEmail(emailFromLocation);
    } else {
      setEmailNotFoundInLocation(true);
    }
  }, [email, location, setEmail]);

  if (!email) {
    // If we were unable to find the email in the history state,
    // we still want to drop a user to login; it just won't
    // have the email field pre-filled.
    return emailNotFoundInLocation ? (
      <Redirect to={ROUTES.LOGIN} />
    ) : (
      <DelayedLoadingIndicator />
    );
  }

  const onSubmit = () => {
    history.replace(ROUTES.LOGIN);
  };

  return <ExistingAccountView onSubmit={onSubmit} email={email} />;
};
